import type {DocumentManager} from '@wix/document-manager-core'
import type {MasterPageMigrator} from '../dataMigrationRunner'
import _ from 'lodash'
import {VIEW_MODES, DATA_TYPES, MASTER_PAGE_ID} from '../../../../constants/constants'
import type {RelationshipsAPI} from '../../../relationships'
import type {PageExtensionAPI} from '../../../page'

const migrateMasterPage = (documentManager: DocumentManager) => {
    const {extensionAPI, pointers, dal} = documentManager
    const {page} = extensionAPI as PageExtensionAPI
    if (documentManager.config.loadingPartialPages) {
        return
    }
    const pageIds = page.getAllPagesIds(false)
    _.forEach(pageIds, pageId => {
        const pageMobilePointer = pointers.structure.getPage(pageId, VIEW_MODES.MOBILE)
        const pageDesktopPointer = pointers.structure.getPage(pageId, VIEW_MODES.DESKTOP)
        if (!dal.has(pageDesktopPointer) && !dal.has(pageMobilePointer)) {
            const dataPointerToRemove = pointers.data.getItem(DATA_TYPES.data, pageId, MASTER_PAGE_ID)
            const {relationships} = extensionAPI as RelationshipsAPI
            const references = relationships.getReferencesToPointer(dataPointerToRemove)
            if (_.isEmpty(references)) {
                dal.remove(dataPointerToRemove)
            }
        }
    })
}

const name = 'removePageDataWithNoStructure'
const version = 4
const disableVersioning = (documentManager: DocumentManager) => documentManager.config.loadingPartialPages ?? false

export const removePageDataWithNoStructure: MasterPageMigrator = {
    migrateMasterPage,
    name,
    version,
    disableVersioning
}
